import CryptoJS from "crypto-js";
import configData from "../appconfig/config.json";

const SECRET = String(configData.CRYPT || "");
//const SECRET = String(configData.CRYPT);
const key = CryptoJS.enc.Utf8.parse(SECRET);
const iv = CryptoJS.enc.Utf8.parse(SECRET);

export const decryptAesText = (cipherText) => {
  if (!cipherText) return cipherText;
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, key, { iv });
    const plainText = bytes.toString(CryptoJS.enc.Utf8);
    return plainText || cipherText; // fallback to original when decrypt fails
  } catch (e) {
    return cipherText;
  }
};

export const encryptAesText = (plainText) => {
  if (plainText === null || plainText === undefined || plainText === "") return plainText;
  try {
    return CryptoJS.AES.encrypt(String(plainText), key, { iv }).toString();
  } catch (e) {
    return plainText;
  }
};